export default __webpack_public_path__ + "static/media/Hard Rehearsal.5f8317f8.png";